const investment = {
  '--primary': '#1C2939',
  '--secondary': '#00205B',
  '--tertiary': '#D9E6F4',
  '--interaction': '#3CD77A',
  '--accent': '#0057B7',
};
export default investment;
